import { uniqueNamesGenerator, adjectives, colors, animals } from 'unique-names-generator';

function simpleHash(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return Math.abs(hash);
}

export function generateAnonymousUsername(baseString: string): string {
  const seed = simpleHash(baseString);
  return uniqueNamesGenerator({
    dictionaries: [adjectives, colors, animals],
    seed,
    separator: '-',
    length: 3,
    style: 'lowerCase',
  });
}
